<template>
	<modal
		@close="$emit('close')"
		:clickBackdropClosing="false"
		width="95%"
		:showModalCloseButton="false"
		:noTitleBar="true"
		:forceHeight="forceHeight"
		:maxWidth="maxWidth"
	>
		<div>
			<div class="popup-gray-close-button absolute" @click="$emit('close')">
				<img src="/img/close_cross@2x.png" />
			</div>

			<div class="row m-0">
				<div class="col-12 col-sm-4 p-0">
					<inline-photo-viewer
						v-if="imageItems.length"
						:images="imageItems"
						:context="context"
						:provider="provider"
					/>
					<div style="clear:both;"></div>
					<booking-pass-content
						v-if="pass"
						:show-price="false"
						:context="context"
						:provider="provider"
						:booking-pass="pass"
					/>
				</div>

				<div class="col-12 col-sm-8 booking-table">
					<loading-indicator
						v-if="isLoadingBooking"
						:full-parent="true"
						:clear-background="true"
						:is-loading="true"
					/>
					<template v-else>
						<div v-if="bookings.length === 0" class="text-center text-muted">
							{{$t('booking_passes.no_bookings')}}
						</div>
						<table v-else class="w-100 ding-table" border=0>
							<thead>
								<th>{{$t('booking_passes.service')}}</th>
								<th>{{$t('booking_passes.status')}}</th>
							</thead>
							<tbody>
								<tr v-for="b in bookings" :key="b.id" class="cursor-pointer" @click="openBookingToCheck(b)">
									<td>
										<div>{{b.display_datetime}}</div>
										<div><b>{{b.member_user.name}}</b></div>
										<div>{{b.service.title}}</div>
									</td>
									<td>
										<div	
											v-if="isBookingOverdue(b) && b.status.toLowerCase() === 'unapproved'"
											v-b-tooltip.hover
											class="mt-1 label label-muted" 
											:id="'booking-tooltip-target-' + b.id">
											{{$t('booking.has_past_no_reply')}}</div>
										<div v-else class="label mt-1" :class="getLabelClassForBooking(b)">
											{{$t('provider.booking_status_' + b.status.toLowerCase())}}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</template>
				</div>
			</div>
		</div>

		<template v-if="bookingToCheck">
			<booking-group
				v-if="customerId"
				:initBooking="bookingToCheck"
				:context="context"
				@close="bookingToCheck = null" />

			<customer-booking-checker
				v-else
				ref="bookingChecker"
				:context="context"
				:provider="provider"
				@close="bookingToCheck = null" />
		</template>
	</modal>
</template>

<script>
import api from '../mixins/api';
import promptConfirm from '../mixins/prompt-confirm';
import BookingPassContent from './booking_passes/BookingPassContent.vue';
import InlinePhotoViewer from './common/InlinePhotoViewer.vue';
import LoadingIndicator from './common/LoadingIndicator.vue';
import moment from 'moment';
import CustomerBookingChecker from './landing/CustomerBookingChecker.vue';
import BookingGroup from './booking/BookingGroup.vue';

export default {
	components: { BookingPassContent, InlinePhotoViewer, LoadingIndicator, CustomerBookingChecker, BookingGroup },
	mixins: [api, promptConfirm],
	props: {
		context: { required: true, type: Object },
		provider: { required: true, type: Object },
		pass: { required: true, type: Object },
		customerBookingPass: { required: true, type: Object },
		customerId: { required: false }, // 如果是廠商後台看的話，會直接指名 customerId
	},
	data() {
		const isMobile = window.innerWidth <= 480;
		let maxWidth = 720;
		if (!isMobile) {
			maxWidth = 860;
			if (this.pass.image) {
				maxWidth -= 80;
			}
		}

		return {
			isMobile,
			maxWidth: maxWidth + 'px',
			forceHeight: isMobile ? '84vh' : '96vh',
			bookings: [],
			isLoadingBooking: false,
			bookingToCheck: null,
		};
	},
	computed: {
		imageItems() {
			var imageItems = [];
			if (this.pass.image) {
				imageItems.push({
					key: `item-${this.pass.image.id}`,
					imageUrl: this.context.storageEndpoint + this.pass.image.file_name
				});
			}
			return imageItems;
		},
	},
	mounted() {
		this.loadBookings();
	},
	methods: {
		loadBookings() {
			if (this.customerBookingPass.id) {
				this.isLoadingBooking = true;
				const callback = (response, error) => {
					this.isLoadingBooking = false;
					if (error) {
						this.promptAlert(error);
					} else {
						this.bookings = response.data;
					}
				};
				if (this.customerId) {
					this.getAllBookingsForCustomerBookingPassByAdmin(this.customerId, this.customerBookingPass.id, callback);
				} else {
					this.getAllBookingsForCustomerBookingPass(this.customerBookingPass.id, callback);
				}
			}
		},
		isBookingOverdue(booking) {
			return moment(booking.start_datetime).isBefore(moment());
		},
		getLabelClassForBooking(booking) {
			if (booking.status.toLowerCase() === 'approved') {
				return 'label-success';
			} else if (booking.status.toLowerCase() === 'rejected') {
				return 'label-danger';
			}
			return 'label-muted';
		},
		openBookingToCheck(booking) {
			this.bookingToCheck = booking;
			this.$nextTick(() => {
				if (this.$refs['bookingChecker']) {
					this.$refs['bookingChecker'].setDisplayIdToCheck(booking.display_id);
				}
			})
		},
	}
}
</script>

<style scoped lang="scss">
.booking-table {
	background-color: #F4F8F9;
	padding: 24px 16px;
}
</style>
